const SCHEMA = 'epeople.workflow.visualization.v1'

function fail(workflow, message) {
  throw new Error(`Workflow ${workflow?.id || 'unknown'}: ${message}`)
}

function isPoint(value) {
  return Array.isArray(value) && value.length === 3 && value.slice(0, 2).every(Number.isFinite) && (value[2] === 0 || value[2] === 1)
}

export function validateWorkflow(workflow) {
  if (!workflow || workflow.schema !== SCHEMA) fail(workflow, `expected schema ${SCHEMA}`)
  if (!Array.isArray(workflow.steps) || !workflow.steps.length) fail(workflow, 'steps must be a non-empty array')
  if (!workflow.masthead || !workflow.map) fail(workflow, 'masthead and map are required')
  for (const role of ['all', 'employee', 'contractor']) {
    if (!/^#[0-9a-f]{6}$/i.test(workflow.theme?.colors?.[role] || '')) fail(workflow, `missing or invalid color for ${role}`)
  }

  const ids = new Set()
  const numbers = new Set()
  const roles = new Set((workflow.roles || []).map(role => role.id))

  workflow.steps.forEach((step, index) => {
    const number = Number(step.number)
    if (!step.id || ids.has(step.id)) fail(workflow, `duplicate or missing step id: ${step.id}`)
    if (!Number.isInteger(number) || number < 1 || numbers.has(number)) fail(workflow, `invalid step number: ${step.number}`)
    if (!roles.has(step.role)) fail(workflow, `unknown role on step ${step.id}: ${step.role}`)
    if (number !== index + 1) fail(workflow, 'step numbers must follow story order from 1')
    ids.add(step.id)
    numbers.add(number)
  })

  const map = workflow.map
  if (!map.viewBox || !Array.isArray(map.tracks) || !Array.isArray(map.nodes)) {
    fail(workflow, 'map.viewBox, map.tracks and map.nodes are required')
  }
  if (map.tracks.length !== map.trackRanges?.length) fail(workflow, 'each track needs a trackRange')

  map.tracks.forEach((track, index) => {
    const range = map.trackRanges[index]
    if (!track.d || !range || !numbers.has(range.start) || !numbers.has(range.end) || range.start >= range.end) {
      fail(workflow, `invalid track or range at index ${index}`)
    }
  })

  map.nodes.forEach(node => {
    if (!numbers.has(node.step) || !roles.has(node.role) || !Number.isFinite(node.x) || !Number.isFinite(node.y) ||
      !Number.isFinite(node.labelX) || !Number.isFinite(node.labelY)) {
      fail(workflow, `invalid map node for step ${node.step}`)
    }
  })

  workflow.steps.forEach(step => {
    const number = Number(step.number)
    const route = map.routes?.[number]
    if (!map.nodes.some(node => node.step === number)) fail(workflow, `missing map node for step ${number}`)
    if (!route || (route.mode !== 'all' && route.mode !== 'split')) fail(workflow, `invalid route for step ${number}`)
    if (route.mode === 'all' && !isPoint(route.all)) fail(workflow, `invalid shared point for step ${number}`)
    if (route.mode === 'split' && (!isPoint(route.employee) || !isPoint(route.contractor))) {
      fail(workflow, `invalid split points for step ${number}`)
    }
  })

  return workflow
}
